import { formatCurrency } from "../../lib/format";

interface DuesSummaryProps {
  buyInPerTeam: number;
  paidCount: number;
  dueCount: number;
}

/** Buy-in, collected, and outstanding as three headline stat cards. */
export function DuesSummary({ buyInPerTeam, paidCount, dueCount }: DuesSummaryProps) {
  return (
    <dl className="payout-stats payout-stats--triple">
      <div className="payout-stats__item">
        <dt>Buy-in per team</dt>
        <dd>{formatCurrency(buyInPerTeam)}</dd>
      </div>
      <div className="payout-stats__item">
        <dt>Collected</dt>
        <dd>{formatCurrency(paidCount * buyInPerTeam)}</dd>
      </div>
      <div className="payout-stats__item">
        <dt>Outstanding</dt>
        <dd>{formatCurrency(dueCount * buyInPerTeam)}</dd>
      </div>
    </dl>
  );
}
